import React, { FC, useContext } from 'react'
import { Button, Form } from '@connectcore/connect-components-react'
import { ALIGN_BUTTONS_AND_LINKS } from '~utils/featureFlags'
import { GO_TO_LOGIN_BUTTON_LABEL } from '~utils/constants'
import { useHistory, useLocation } from 'react-router-dom'
import { IUserContextType, UserContext } from '~utils/context/UserContext'

const RetrieveUsernameSuccess: FC = () => {
  const { setStep, setIsLoading } = useContext(UserContext) as IUserContextType
  const history = useHistory()
  const token = useLocation()?.state?.storeToken

  const handleSubmit = () => {
    setIsLoading(true)
    setStep(undefined)
    history.push({
      pathname: '/',
      state: { storeToken: token },
    })
  }

  return (
    <Form
      onSubmit={() => handleSubmit()}
      className="wide-form"
      data-testid="RetrieveUsernameSuccess"
    >
      <h2 className="fw-bold">Account Profile</h2>
      <br />
      <p>
        An e-mail has been sent to your registered e-mail address with your username. If you do not
        not receive an e-mail within 15 minutes, please try again or contact Customer Care.
      </p>
      <div className="d-flex flex-column">
        <Button kind="primary" className={`my-3 align-${ALIGN_BUTTONS_AND_LINKS}`}>
          {GO_TO_LOGIN_BUTTON_LABEL}
        </Button>
      </div>
    </Form>
  )
}

export default RetrieveUsernameSuccess
